import { GetBaseServiceFunctions } from '../baseService'

const BaseRoute = 'app/imsapprovalcodewiro'

const baseFunctions = GetBaseServiceFunctions(BaseRoute)

const API = {
  ...baseFunctions,
}

export default API
